import { hoursInDay } from "../api/CapsuleProjects";
import type { EntryForDisplay } from "../interfaces/CapsuleEntry";
import type { ProjectSummary } from "../interfaces/ProjectSummary";

interface ProjectSummaryHeaderProps {
	project: ProjectSummary;
	text: string;
	supportHours?: number;
	commencementDate?: Date;
	contractTerm?: number;
	entriesData?: EntryForDisplay[];
}

export const ProjectSummaryHeader = ({
	project,
	text,
	...props
}: ProjectSummaryHeaderProps) => {
	let minutes_remaining = project.minutes_remaining;
	let minutes_worked = project.minutes_worked;

	if (
		project.project_id.endsWith("ISP") &&
		props.supportHours != null &&
		props.commencementDate != null &&
		props.contractTerm != null &&
		props.entriesData != null
	) {
		//ToDo: Handle out of contract period

		const now = new Date();
		const anniversaryDay = props.commencementDate.getDate();
		const anniversaryMonth = props.commencementDate.getMonth() + 1;
		let lastAnniversaryYear = props.commencementDate.getFullYear();
		let nextAnniversaryYear = lastAnniversaryYear + 1;

		let lastAnniversaryDate = new Date(
			`${lastAnniversaryYear}-${anniversaryMonth}-${anniversaryDay}`,
		);
		let nextAnniversaryDate = new Date(
			`${nextAnniversaryYear}-${anniversaryMonth}-${anniversaryDay}`,
		);

		// Upcoming anniversary dates are...
		for (let i = 0; i < props.contractTerm; i++) {
			lastAnniversaryDate = new Date(
				`${lastAnniversaryYear}-${anniversaryMonth}-${anniversaryDay}`,
			);
			nextAnniversaryDate = new Date(
				`${nextAnniversaryYear}-${anniversaryMonth}-${anniversaryDay}`,
			);
			if (now.getTime() < nextAnniversaryDate.getTime()) {
				break;
			}
			lastAnniversaryYear = lastAnniversaryYear + 1;
			nextAnniversaryYear = nextAnniversaryYear + 1;
		}

		const entriesData = props.entriesData.filter((f) => {
			const year = f.date.substring(6, 10);
			const month = f.date.substring(3, 5);
			const day = f.date.substring(0, 2);
			const entryDate = new Date(`${year}-${month}-${day}`);

			return (
				entryDate.getTime() > lastAnniversaryDate.getTime() &&
				entryDate.getTime() < nextAnniversaryDate.getTime()
			);
		});

		minutes_worked = entriesData.reduce(
			(partialSum, a) => partialSum + a.minutes,
			0,
		);
		minutes_remaining =
			project.allocated_days * hoursInDay * 60 - minutes_worked;
	}

	return (
		<div className="flex padded-bottom">
			<h3 className={"header-with-sub"}>{text}</h3>
			<i className={"sub-header"}>
				{project.project_id.endsWith("ISP") &&
				(props.supportHours == null ||
					props.commencementDate == null ||
					props.contractTerm == null ||
					props.entriesData == null) ? (
					"ISP Project Detected - See History Card for Remaining Hours Summary"
				) : (
					<>
						{"Project Status: " +
							(minutes_worked / 60 / hoursInDay).toFixed(2) +
							" days of " +
							project.allocated_days +
							" days used "}
						<span className={"warning"}>
							{minutes_remaining < 1 &&
								minutes_worked !== 0 &&
								`(${(minutes_remaining / 60).toFixed(1)} hours remaining)`}
						</span>
					</>
				)}
			</i>
		</div>
	);
};
